import { useQuery } from "react-query";
import { getAllPlansRequest } from "./request";


export const useFetchPlansAll = () => {
    return useQuery(["UsePlansAll"], getAllPlansRequest);
};